import React, {useContext} from 'react'
import styles from '../Cesion/Cesion.module.css'
//Context
import GeneralContext from '../../context/GeneralContext'

const Cesion = ({ state, setState }) => {
  const { state: generalState } = useContext(GeneralContext)
  let user = generalState.users.filter((user) => user.isAuthenticated)[0]
  let prospecto = user.listaProspectos.filter(
      (prospecto) => prospecto.isSelected || prospecto.completado
  )[0]
  let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

  //funcion que actualiza el estado del parametro CondicionCesionDerechos
  const handleChangeCesion = (e) => {
    let isValue = e.target.value === 'true'? true : false
    setState((state) => {
      return {
        ...state,
        condicionCesionDerechos: isValue,
      }
    })
  }

  //Modo lectura
  let Deshabilitar = (complete) => {
    complete = cotizacion.edicionInhabilitada
    if (complete === true) {
        return true
    } else {
        return false
    }
  }

  return (
    <div>
      <div className={styles['areadatosprospecto']}>
        <div className={styles['areadatosprospecto__subtitulo']}>
          <h1 sname='Cesión del derecho de designación de beneficiarios' smostrar='true'>
            Cesión del derecho de designación de Beneficiario
          </h1>
        </div>
        <p className={styles['dataley']}>
            El Contratante cede en forma expresa, incondicional y de manera irrevocable a favor del Propuesto Asegurado,
          el derecho a nombrar al Beneficiario o los Beneficiarios del contrato de seguro de ser aprobada esta solicitud. De esta manera, el Propuesto
          Asegurado podrá modificar la designación de los Beneficiarios, detallados a continuación, las veces que lo considere necesario.
        </p>
        <br/><br/>
        <div>
          <label>
            <input name='light' type='radio' value={true} 
              checked={state.condicionCesionDerechos === true}
              selected={state.condicionCesionDerechos === true}
              onChange={handleChangeCesion}
              disabled={Deshabilitar() !== true ? false : true}
            />
            <span className="span-radio-si-no">Sí</span>
          </label>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <label>
            <input
              name='light'
              type='radio'
              value={false}
              checked={state.condicionCesionDerechos === false}
              selected={state.condicionCesionDerechos === false}
              onChange={handleChangeCesion}
              disabled={Deshabilitar() !== true ? false : true}
            />
            <span className="span-radio-si-no">No</span>
          </label>
        </div>
      </div>

      <div></div>
    </div>
  )
}

export default Cesion
